import { gql } from '@apollo/client';


export const ADDRESS_AUTO_SUGGEST = gql`
  query addressAutoSuggest($input: String!, $count: Int!, $originatorId: ID!){
    addressAutoSuggest(input: $input, count: $count, originatorId: $originatorId) {
      id
      match
      value
    }
  }
`;